import { Form, Row } from "antd";
import styled, { css } from "styled-components";
import { theme } from "../../../config";
import { MinusCircleOutlined } from "@ant-design/icons";
import { TextInput } from "../../atoms/TextInput";
export const FormItem = styled(Form.Item)`
  height: 85px;
  ${theme.formErrorMobileView}
  @media ${theme.breakpoints.mobileAndTablet} {
    height: 70px;
  }
`;

export const ContactTimeFormItem = styled(Form.Item)`
  height: 85px;
  ${theme.formErrorMobileView}

  .ant-select-item-option-disabled {
    color: rgba(0, 0, 0, 0.25) !important;
  }

  @media ${theme.breakpoints.mobileAndTablet} {
    height: 70px;
  }
`;

export const ContactTimeToFormItem = styled(Form.Item)`
  height: 85px;
  ${theme.formErrorMobileView}

  .ant-select-item-option-disabled {
    color: rgba(0, 0, 0, 0.25) !important;
  }
  
  @media ${theme.breakpoints.mobileAndTablet} {
    height: 50px;
    margin-bottom: 5px;
  }
`;

export const FormItemWrapper = styled.div`
  width: 202px;
  @media ${theme.breakpoints.mobile} {
    margin-left: 2px;
    margin-right: 2px;
  }
  @media ${theme.breakpoints.mobileAndTablet} {
    width: 100%;
  }
  @media ${theme.breakpoints.tablet} {
    margin-left: 4px;
    margin-right: 4px;
  }
`;

export const FormItemWrapperLeft = styled.div`
  margin-left: 8px;
  margin-right: 16px;
  width: 202px;
  @media ${theme.breakpoints.mobile} {
    margin-left: 2px;
    margin-right: 2px;
  }
  @media ${theme.breakpoints.mobileAndTablet} {
    width: 100%;
  }
  @media ${theme.breakpoints.tablet} {
    margin-left: 4px;
    margin-right: 4px;
  }
`;

export const CharRefInputWrapper = styled(Row)`
  ${theme.formErrorMobileView}
  @media ${theme.breakpoints.mobile} {
  }
  @media ${theme.breakpoints.mobileAndTablet} {
    width: 100%;
  }
  @media ${theme.breakpoints.tablet} {
  }

  .ant-form-item-explain.ant-form-item-explain-error {
    @media ${theme.breakpoints.mobileAndTablet} {
      margin-left: 0;
    }
  }
`;

export const CharRefRow = styled.div`
  display: flex;
  margin-bottom: 35px;
  align-items: center;
  margin-left: 8px;
  @media ${theme.breakpoints.mobileAndTablet} {
    display: block;
    width: 100%;
    margin-left: 0;
    margin-bottom: 25px;
  }
`;

export const NameContactNumberDiv = styled.div`
  display: flex;

  @media ${theme.breakpoints.mobileAndTablet} {
    width: 100%;
    display: block;
  }
`;

const ItemWrapper = css`
  width: 202px;
  height: 60px;
  @media ${theme.breakpoints.mobileAndTablet} {
    width: 100%;
    height: 50px;
    min-height: 50px;
  }
`;

export const CharRefFormItemWrapper = styled.div`
  ${ItemWrapper}
`;

export const CharRefFormItemWrapperLeft = styled.div`
  ${ItemWrapper}
  margin-right: 16px;

  @media ${theme.breakpoints.mobileAndTablet} {
    margin: 0;
  }
`;

export const RelationshipFormItemWrapper = styled.div`
  width: 100%;
  height: 50px;
  @media ${theme.breakpoints.mobileAndTablet} {
    width: 100%;
  }
`;

export const EmailCharRefFormItemWrapper = styled.div`
  width: 100%;
  height: 50px;
  margin-bottom: 10px;
  @media ${theme.breakpoints.mobileAndTablet} {
    width: 100%;
    margin-bottom: 0px;
  }
`;

export const InputTitle = styled.p`
  margin-top: 18px;

  color: ${theme.colors.dark};

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 12.6px;
    line-height: 16px;
    margin-top: 30px;
  }
`;

export const CharRefRadioText = styled.p`
  line-height: 18px;
  font-size: 14px;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 12.6px;
    display: block;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: -10px;

  @media ${theme.breakpoints.mobileAndTablet} {
    margin-top: -15px;
  }
`;

export const IconWrapper = styled.div`
  margin-left: 15px;
  margin-bottom: 7px;

  @media ${theme.breakpoints.mobileAndTablet} {
    margin-top: 5px;
    margin-left: 0;
  }
  @media ${theme.breakpoints.mobile} {
    margin-top: 8px;
    margin-left: 0;
  }
`;

export const MinusCircleIcon = styled(MinusCircleOutlined)`
  font-size: 20px;
  color: ${theme.colors.utilities.error};
`;

export const StyledTextInput = styled(TextInput)`
  height: 39px;
  margin-bottom: 17px;
`;

export const CharacterRefContainer = styled.div`
  & > * {
    padding-bottom: 20px;
    & :last-child {
      // padding-bottom: 5px;
    }
  }
`;

export const RadioContainer = styled.div`
  padding: 20px 0 0 0;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 10px 0 0 0;
  }
`;
